/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CanvasArea } from "./CanvasArea";
export const CanvasAreaResponse = core.serialization.object({
    data: CanvasArea,
});
